import { useApiQuery } from 'hooks/useApiQuery'

export const useGetSweepstakeById = ({
  sweepstakeId,
}: {
  sweepstakeId?: number
}) =>
  useApiQuery({
    path: '/le-connect/contests/{id}',
    method: 'get',
    queryKey: ['/sweepstakes/by-id', sweepstakeId],
    queryArgs: { id: sweepstakeId },
    enabled: sweepstakeId != null,
  })
